// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ConnectRequiredInfo: MarkdocTagRegistration = {
  tag: 'connect-required-info',
  component: 'ConnectRequiredInfo',
  description: 'Dynamic required verification info component',
  attributes: {
    countryMapData: {
      type: String,
      default: '{}',
      description: 'JSON encoded dictionary of country_code -> display name',
    },
    countryTosMapData: {
      type: String,
      default: '{}',
      description: 'JSON encoded dictionary of country_code -> [tos_types]',
    },
    entityTypeStructureMapData: {
      type: String,
      default: '{}',
      description:
        'JSON encoded dictionary of country_code -> {entity_type -> [avail_structures...]}',
    },
    capabilityTypesData: {
      type: String,
      default: '[]',
      description: 'JSON encoded array of available capabilities',
    },
  },
};
